import React from 'react';
import { Dropdown, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { setLanguage } from '@store/slices/languageSlice';

/**
 * LanguageSwitcher Component
 *
 * Provides a dropdown to switch between English and Arabic languages.
 * Integrates with Redux for state management and i18next for translations.
 */
const LanguageSwitcher = ({ type = 'default', size = 'middle', showText = false }) => {
  const dispatch = useAppDispatch();
  const { current: currentLanguage } = useAppSelector((state) => state.language);

  const languageItems = [
    {
      key: 'en',
      label: 'English',
      onClick: () => dispatch(setLanguage('en')),
    },
    {
      key: 'ar',
      label: 'العربية',
      onClick: () => dispatch(setLanguage('ar')),
    },
  ];

  const currentLanguageLabel = currentLanguage === 'en' ? 'EN' : 'AR';
  const currentLanguageFull = currentLanguage === 'en' ? 'English' : 'العربية';

  return (
    <Dropdown
      menu={{
        items: languageItems,
        selectedKeys: [currentLanguage]
      }}
      placement="bottomRight"
      trigger={['click']}
    >
      <Button type={type} icon={<GlobalOutlined />} size={size}>
        {showText ? currentLanguageFull : currentLanguageLabel}
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
